import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { DataService } from 'app/shared/services/data/data.service';
import { Spot, Feed } from 'app/shared/models/SportySky/spotSportySky';

@Component({
  selector: 'app-meteo-details',
  templateUrl: './meteo-details.component.html',
  styleUrls: ['./meteo-details.component.scss']
})
export class MeteoDetailsComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() set city(value: Spot) {
    this.newCity = value;
    this.infoCity = this.newCity.feeds[0];
    this.getWind(this.newCity);
  }

  newCity: Spot;
  infoCity: Feed;

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
  }

  getWind(spot): void {
    const wind = spot.feeds[0].windDirectionString.toLowerCase();
    const divDirection = document.querySelectorAll('.direction');

    divDirection.forEach(el => {
      el.classList.remove('direction_orange');
    });
    document.getElementById(`${wind}`).classList.add('direction_orange');
  }
}
